import { useMutation, useQueryClient } from "@tanstack/react-query";
import { createVendor } from "api/vendor.api";
import { invalidateVendorSide } from "lib/cacheInvalidation";

export const useCreateVendor = () => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: createVendor,
    onSuccess: () => invalidateVendorSide(queryClient),
  });
};
